// src/theme/ThemeContext.js
import React, { createContext, useMemo, useState, useContext } from "react";
import { createTheme, ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Create the context
const ThemeContext = createContext();

const lightTheme = {
  palette: {
    mode: "light",
    primary: { main: "#1976d2" },
    background: { default: "#f5f5f5", paper: "#fff" },
    text: { primary: "#000", secondary: "#555" },
  },
  
};

const darkTheme = {
  palette: {
    mode: "dark",
    primary: { main: "#00eaff" },
    background: { default: "#0d1b2a", paper: "#1a1a2e" },
    text: { primary: "#e0e0e0", secondary: "#00eaff" },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
    h6: { color: "#00eaff" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "10px",
          textTransform: "none",
          boxShadow: "0px 0px 10px rgba(0, 234, 255, 0.5)",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: "rgba(26, 26, 46, 0.8)",
          backdropFilter: "blur(10px)",
          borderRadius: "15px",
          padding: "20px",
        },
      },
    },
  },
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(true);

  const toggleTheme = () => setIsDarkMode((prev) => !prev);

  const theme = useMemo(() => createTheme(isDarkMode ? darkTheme : lightTheme), [isDarkMode]);

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => useContext(ThemeContext);
